import {Controller} from '@hotwired/stimulus';

/**
 * Affiche ou masque des blocs selon la valeur d'un champ : groupe de boutons radio, case à cocher
 * ou liste déroulante.
 *
 *   <div {{ stimulus_controller('field-visibility', {field: form.type.vars.full_name})
 *         |stimulus_action('field-visibility', 'update', 'change') }}>
 *     {{ form_row(form.type) }}
 *     <div {{ stimulus_target('field-visibility', 'dependent') }} data-field-visibility-show-on="a b" hidden>…</div>
 *   </div>
 *
 * La valeur du champ est celle de l'entrée cochée, ou de la liste, qui porte le nom `field` ; rien
 * de coché ne correspond à aucune valeur. `data-field-visibility-hide-on` masque au lieu d'afficher
 * (une case `CheckboxType` cochée vaut `1`). Le Twig rend l'état initial (`hidden`). Un bloc masqué
 * n'est ni vidé ni désactivé : son champ reste posté.
 */
export default class extends Controller {
  static targets = ['dependent'];
  static values = {
    field: String,
  };

  connect() {
    this.update();
  }

  update() {
    const value = this.#fieldValue();

    this.dependentTargets.forEach((dependent) => {
      dependent.hidden = !this.#isShown(dependent, value);
    });
  }

  #fieldValue() {
    const field = [...this.element.querySelectorAll('input, select')]
      .find((element) => element.name === this.fieldValue && (element instanceof HTMLSelectElement || element.checked));

    return field ? field.value : '';
  }

  #isShown(dependent, value) {
    const {fieldVisibilityShowOn: showOn, fieldVisibilityHideOn: hideOn} = dependent.dataset;

    if (showOn !== undefined) {
      return this.#values(showOn).includes(value);
    }

    if (hideOn !== undefined) {
      return !this.#values(hideOn).includes(value);
    }

    return true;
  }

  #values(attribute) {
    return attribute.split(/\s+/).filter((value) => value !== '');
  }
}
